var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plus-button",on:{"click":_vm.onClicked}},[_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.icons('plus'))}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }